import React from 'react'
import Conditional from '../../../common/Conditional'
import '../../Enquiries.css'

export interface IEnquiryDetailRowProps {
  title: string
  values?: string[]
  value?: string
  showDefaultAnswer?: boolean
}

const EnquiryDetailRow = (props: IEnquiryDetailRowProps) => {
  return (
    <>
      <Conditional
        if={
          (props.value === null || props.value === undefined) &&
          (props.values === null || props.values === undefined)
        }
      >
        <tr>
          <td>
            <strong>{props?.title}</strong>
          </td>
          <td>{props.showDefaultAnswer === false ? '' : 'Not answered'}</td>
        </tr>
      </Conditional>
      <Conditional if={props.value !== null && props.value?.length > 0}>
        <tr>
          <td>
            <strong>{props?.title}</strong>
          </td>
          <td>{props?.value}</td>
        </tr>
      </Conditional>
      <Conditional if={props.values?.length > 0}>
        <tr>
          <td>
            <strong>{props?.title}</strong>
          </td>
          <td>
            <ol>
              {props?.values?.map((st, index) => (
                <li className="no-bullets" key={index}>
                  {st}
                </li>
              ))}
            </ol>
          </td>
        </tr>
      </Conditional>
    </>
  )
}

export default EnquiryDetailRow
